import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const propTypes = {
	to: PropTypes.string.isRequired,
	target: PropTypes.string,
	'data-spec': PropTypes.string,
	children: PropTypes.node.isRequired,
};

// Link that also works for external URLs
const DynamicLink = props => {
	// Attribute 'target' won't be added for internal routes
	const linkProps = {
		...props,
		target: undefined,
	};
	// Attribute 'to' won't be added for external urls
	const aProps = {
		...props,
		to: undefined,
	};
	const { to, children } = props;

	// If 'to' attribute begins with http(s):// use an <a> tag,
	// otherwise use <Link>
	return /^https?:\/\//.test(to) ? (
		<a href={to} {...aProps}>
			{children}
		</a>
	) : (
		<Link {...linkProps} />
	);
};

DynamicLink.propTypes = propTypes;

export { DynamicLink };
